// hooks/useDepthChart.js
import { useQuery } from "@tanstack/react-query";

const rapidApiHost = process.env.REACT_APP_RAPID_API_HOST;
const rapidApiKey = process.env.REACT_APP_RAPID_API_KEY;

// Custom hook for fetching depth chart data
export function useDepthChart() {
  return useQuery({
    queryKey: ["depthChart"],
    queryFn: async () => {
      //console.log("🌐 Making Depth Chart API call...");
      const response = await fetch(
        "https://tank01-nfl-live-in-game-real-time-statistics-nfl.p.rapidapi.com/getNFLDepthCharts",
        {
          method: "GET",
          headers: {
            "x-rapidapi-host": rapidApiHost,
            "x-rapidapi-key": rapidApiKey,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        ...data,
        fetchedAt: new Date().toLocaleTimeString(),
      };
    },
    staleTime: 96 * 60 * 60 * 1000, // 4 days
    cacheTime: 168 * 60 * 60 * 1000, // 7 days
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}

// Component for displaying depth chart
export function GetQB1(props) {
  const { data, isLoading, error } = useDepthChart();

  if (isLoading) return <div>Loading depth chart...</div>;
  if (error) return <div>Error loading depth chart: {error.message}</div>;

  const getQBs = data?.body?.map((t) => ({
    TeamAbv: t.teamAbv,
    TeamName: t.TeamName,
    Coach: t.Coach,
    QB1: t.depthChart.QB?.[0]?.longName || "N/A",
    QB2: t.depthChart.QB?.[1]?.longName || "N/A",
  }));

  const teamQBs = getQBs.find((q) => q.TeamAbv === props.k);

  return <>{teamQBs.QB1}</>;
}

export function GetDepthRow(props) {
  const { data, isLoading, error } = useDepthChart();

  if (isLoading) return <div>Loading depth chart...</div>;
  if (error) return <div>Error loading depth chart: {error.message}</div>;

  const getPeeps = data?.body?.map((t) => ({
    TeamAbv: t.teamAbv,
    QB1: t.depthChart.QB?.[0]?.longName || "N/A",
    QB2: t.depthChart.QB?.[1]?.longName || "N/A",
    WR1: t.depthChart.WR?.[0]?.longName || "N/A",
    WR2: t.depthChart.WR?.[1]?.longName || "N/A",
    WR3: t.depthChart.WR?.[2]?.longName || "N/A",
    RB1: t.depthChart.RB?.[0]?.longName || "N/A",
    RB2: t.depthChart.RB?.[1]?.longName || "N/A",
    TE1: t.depthChart.TE?.[0]?.longName || "N/A",
    TE2: t.depthChart.TE?.[1]?.longName || "N/A",
  }));

  const teamPeeps = getPeeps.find((q) => q.TeamAbv === props.k);

  return (
    <>
      <div>
        <span className="playerBubble">{teamPeeps.QB1}</span>
        
        <span className="playerBubble"><i style={{ fontSize: ".9em" }}>{teamPeeps.QB2}</i></span>
      </div>
      <div>
        <span className="playerBubble">{teamPeeps.WR1}</span><span className="playerBubble">{teamPeeps.WR2}</span><span className="playerBubble">{teamPeeps.WR3}</span>
      </div>
      <div>
        <span className="playerBubble">{teamPeeps.RB1}</span><span className="playerBubble">{teamPeeps.RB2}</span>
      </div>
      <div>
        <span className="playerBubble">{teamPeeps.TE1}</span><span className="playerBubble">{teamPeeps.TE2}</span>
      </div>
    </>
  );
}
